import { Record as record } from 'immutable';

import { construct, fields } from '../helpers/LinkMapper';

const defaults = {
    code: null,
    description: null,
    fixedAmount: null,
    name: null,
    percentage: null,
};

class OrderDiscount extends record(defaults) {

    static fromJSON (json = {}) {
        return construct(OrderDiscount, json, {
            code: fields.string,
            description: fields.string,
            fixedAmount: fields.number,
            name: fields.string,
            percentage: fields.number,
        });
    }
}

export default OrderDiscount;
